import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayeeSelectionComponent } from './payee-selection.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MatSelectModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatInputModule,
  ],
  exports: [PayeeSelectionComponent],
  declarations: [PayeeSelectionComponent],
})
export class PayeeSelectionModule {}
